import { useParams } from 'react-router-dom';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import { Grid } from '@mui/material';
import GridContainer from 'components/GridContainer';
import Spacing from 'components/Spacing';
import CompanyForm from './CompanyForm';
import FormWrapper from './FormWrapper';
import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import api from 'lib/trpcClient';

const pageTitle = 'Holdings: Manage company';

const AddEditCompany: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { vehicle } = useLayoutContext();

  const { data: company, isLoading: isCompanyLoading } =
    api.lpCompany.get.useQuery(
      {
        companyId: id ?? '',
        vehicleId: vehicle?._id ?? '',
      },
      {
        enabled: !!id && !!vehicle?._id,
      },
    );

  const breadcrumbs = [
    { label: 'Dashboard' },
    { label: 'Companies', link: '/lp-companies/list' },
    {
      label: id ? 'Edit Company' : 'Add Company',
      link: '/',
      isActive: true,
    },
  ];

  if (isCompanyLoading || !vehicle) {
    return <PageLoader />;
  }

  return (
    <PageContainer heading={pageTitle} breadcrumbs={breadcrumbs}>
      <PageContent>
        <Spacing size="lg">
          <GridContainer>
            <Grid size={{ xs: 12 }}>
              <FormWrapper selectedVehicle={vehicle} values={company}>
                <CompanyForm selectedVehicle={vehicle} companyId={id} />
              </FormWrapper>
            </Grid>
          </GridContainer>
        </Spacing>
      </PageContent>
    </PageContainer>
  );
};

export default AddEditCompany;
